import { getRoleFromLocal } from "../globals/authentication";

/**
 * Logs an analytic event to Google Analytics asynchronously
 *
 * @param {string} eventName - The name of the event to track (e.g., 'page_view', 'button_click')
 * @param {Object} [eventParams={}] - Optional parameters associated with the event
 * @param {Object} [options={}] - Optional configuration for the analytics call
 * @param {boolean} [options.nonInteraction=false] - Whether this is a non-interaction event
 * @returns {Promise<boolean>} - Promise resolving to true if the event was successfully logged, false otherwise
 */
export const logEvent = async (eventName, eventParams = {}, options = {}) => {
  try {
    // Check if Google Analytics is loaded
    if (typeof window === "undefined" || !window.gtag) {
      console.warn("Google Analytics not loaded");
      return false;
    }

    // Prepare the event parameters
    const params = {
      ...eventParams,
      non_interaction: options.nonInteraction || false,
    };

    // Send the event to Google Analytics
    window.gtag("event", eventName, params);

    return true;
  } catch (error) {
    console.error("Error logging analytics event:", error);
    return false;
  }
};

/**
 * Utility function to track page views asynchronously
 *
 * @param {string} pagePath - The path of the page being viewed
 * @param {string} pageTitle - The title of the page being viewed
 * @returns {Promise<boolean>} - Promise resolving to true if the event was successfully logged, false otherwise
 */
export const trackPageView = async () => {
  return await logEvent("load_page", {
    page_path: window.location.pathname,
    user_role: getRoleFromLocal(),
  });
};
